import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 font-mono-t text-xs uppercase tracking-[0.25em] text-mk-yellow ${className}`}>
    <span className="h-px w-8 bg-mk-yellow" />
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, sub, testid, caps = false }) => (
  <Reveal className="max-w-3xl">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className={`mt-5 font-heading text-4xl font-extrabold leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl ${caps ? "uppercase" : ""}`} data-testid={testid}>{title}</h2>
    {sub && <p className="mt-6 max-w-2xl text-sm text-mk-muted md:text-lg">{sub}</p>}
  </Reveal>
);

const VARIANTS = {
  primary: "bg-mk-yellow text-black hover:bg-white",
  ghost: "border border-white/20 text-white hover:border-mk-yellow hover:text-mk-yellow",
};

export const MkButton = ({ to, variant = "primary", children, className = "", ...rest }) => (
  <Link
    to={to}
    className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.97] ${VARIANTS[variant]} ${className}`}
    {...rest}
  >
    {children}
  </Link>
);

export const BrowserFrame = ({ src, alt, className = "" }) => (
  <div className={`overflow-hidden rounded-xl border border-white/10 bg-mk-navy shadow-[0_40px_120px_-30px_rgba(0,81,255,0.35)] ${className}`}>
    <div className="flex items-center gap-1.5 border-b border-white/10 px-4 py-3">
      <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      <span className="ml-3 font-mono-t text-[10px] tracking-wider text-white/30">kihap.app</span>
    </div>
    <img src={src} alt={alt} loading="lazy" className="block w-full" />
  </div>
);

export const Rich = ({ text }) => (
  <>{text.split(/\*\*(.+?)\*\*/g).map((p, i) => (i % 2 ? <strong key={i} className="font-semibold text-white">{p}</strong> : p))}</>
);
